import RiveAnimation from "@/components/Common/RiveAnimation/RiveAnimation";
import { LoginContent } from "@/components/LoginContent/LoginContent";
import { useUserStore } from "@/store/user";
import { cn } from "@/utils/styles";

type LoginPanelContentProps = {
  title: React.ReactNode;
  description: string;
  isOpen: boolean;
  isSignUp: boolean;
  onChangeIsSignUp: (isSignUp: boolean) => void;
  titleClassName?: string;
  className?: string;
};

export const LoginPanelContent: React.FC<LoginPanelContentProps> = ({
  title,
  description,
  isOpen,
  isSignUp,
  onChangeIsSignUp,
  titleClassName,
  className
}) => {
  const theme = useUserStore((state) => state.theme);

  return (
    <div className={cn("relative z-[1] flex flex-1 flex-col gap-7", className)}>
      {theme === "dark" ? (
        <div className="absolute bottom-0 h-[600px] w-full overflow-hidden max-md:hidden">
          <RiveAnimation
            thumbnail="/assets/video/io.net.png"
            src="/assets/video/io.net.riv"
            width={918}
            height={600}
            className="absolute left-[240px] top-[45px] h-[600px] w-[918px]"
          />
        </div>
      ) : (
        <img
          className="absolute right-0 top-0 h-full overflow-hidden object-contain max-md:hidden"
          src="/assets/images/login/background-light.png"
        />
      )}

      <div className="flex flex-col gap-3 p-7 pb-0">
        <div className={cn("text-5xl font-medium text-foreground", titleClassName)}>{title}</div>
        <div className="text-base font-normal text-gray-dark-2200">{description}</div>
      </div>

      <LoginContent
        className="relative z-[1]"
        isOpen={isOpen}
        isSignUp={isSignUp}
        onChangeIsSignUp={onChangeIsSignUp}
      />
    </div>
  );
};
